import {
  ContractDetailsOtherContractInformationCustomFieldFragment,
  ContractDetailsOtherContractInformationCustomValueFragment,
} from 'generated/resources/graphql'

import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'
import centsToDecimal from 'modules/core/lib/formatCents'

import Item from 'modules/contracts/components/ContractDetails/OtherContractInformation/Item'

interface Props {
  customField: ContractDetailsOtherContractInformationCustomFieldFragment
  customValue?: ContractDetailsOtherContractInformationCustomValueFragment
}

const CustomField = ({ customField, customValue }: Props) => {
  let description = undefined

  switch (customField.fieldType) {
    case 'text':
    case 'long_text':
      description = customValue?.longTextValue
      break
    case 'single_choice':
      description = customValue?.singleChoiceValue
      break
    case 'cents':
      const centsValue = customValue?.centsValue
      const isValidCentsValue =
        centsValue !== null &&
        centsValue !== undefined &&
        centsValue !== '' &&
        !isNaN(Number(centsValue))

      description = isValidCentsValue ? centsToDecimal(centsValue).toString() : undefined
      break
    case 'date':
      const dateValue = customValue?.dateValue
      if (dateValue) {
        description = i18nDateToString(stringToDate(dateValue, 'backend'), 'ui_dmy_long')
      }
      break
  }

  return <Item title={customField.labelText} description={description} />
}

export default CustomField
